/**
 * Created by ivan on 16.04.18.
 */

const LeaguesToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.LEADER_BOARD);

    this.enable();
};

LeaguesToolbarItem.prototype = Object.create(ToolbarItem.prototype);
LeaguesToolbarItem.prototype.constructor = FriendRequestsToolbarItem;

LeaguesToolbarItem.prototype.onClick = function () {
    if (connector.social.hasLeaderBoard()) {
        connector.social.showLeaderBoard({
            userResult: levels.user.getHumanReadableNumber()
        }, () => {});
        
        return;
    }

    cleverapps.focusManager.display({
        focus: "LeaguesWindow",
        action: function (f) {
            new LeaguesWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

LeaguesToolbarItem.prototype.isVisible = function () {
    if (cleverapps.flags.nomulti && !cleverapps.config.importMode) {
        return false;
    }

    if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation) {
        return false;
    }

    return ToolbarItem.prototype.isVisible.call(this) && cleverapps.leagues.isAvailable();
};
